import { Button2 } from '../Button'
import { CFieldProps } from '@velocity/shared'
import { Form, Formik } from 'formik'
import { CFields } from '../form/Form'

export type BulkUpdateProps = {
  items: { key: string; label: string; fields: CFieldProps[] }[]
  onUpdate: (value: any) => void
  loading?: boolean
}

export default function BulkUpdateDropdown(props: BulkUpdateProps) {
  return (
    <Formik
      initialValues={{ field: '', value1: '' }}
      enableReinitialize={true}
      onSubmit={(values) => {
        const { field, value1, ...rest } = values
        if (field && Object.values(rest).length) props.onUpdate(rest)
      }}
    >
      {({ values }) => (
        <Form className='flex gap-2 items-center'>
          <CFields
            fields={[
              {
                name: 'field',
                placeholder: 'Field',
                type: 'select',
                options: props.items.map((item) => ({
                  label: item.label,
                  value: item.key
                }))
              },
              ...(props.items.find((item) => item.key === values.field)
                ?.fields || [
                { name: 'value1', placeholder: 'New value', type: 'text' }
              ])
            ]}
          />
          <Button2
            title='Bulk Update'
            type='submit'
            loading={props.loading}
            disabled={!values.field}
          />
        </Form>
      )}
    </Formik>
  )
}
